var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Show 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99999 17.8L8.79999 14.3C8.29999 13.7 7.99999 12.9 7.99999 12C7.99999 9.9 9.69999 8.1 11.9 8.1C12.5 8.1 13 8.2 13.5 8.5L16.2 5.2C15 4.4 13.5 4 12 4C7.89999 4 4.19999 6.9 2.09999 11.7C1.99999 11.9 1.99999 12.1 2.09999 12.3C3.09999 14.6 4.39999 16.4 5.99999 17.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70001 11.5C9.60001 11.7 9.60001 11.8 9.60001 12C9.60001 12.4 9.70001 12.8 9.90001 13.1L12.7 9.70004C12.5 9.60004 12.3 9.60004 12.1 9.60004C12 9.60004 11.9 9.60004 11.8 9.60004C11.6 10.7 10.7 11.5 9.70001 11.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9 11.7C21.1 9.80002 20 8.10002 18.7 6.90002L20.6 4.60002C20.7 4.50002 20.8 4.30002 20.8 4.20002C20.8 3.80002 20.5 3.40002 20 3.40002C19.8 3.40002 19.6 3.50002 19.4 3.60002L5.09999 21.2C4.99999 21.3 4.89999 21.5 4.89999 21.7C4.89999 22.1 5.19999 22.5 5.69999 22.5C5.89999 22.5 6.19999 22.4 6.29999 22.2L8.59999 19.3C9.69999 19.7 10.8 20 12 20C16.1 20 19.9 17.1 21.9 12.3C22 12.1 22 11.9 21.9 11.7ZM12 15.9C11.8 15.9 11.6 15.9 11.4 15.9L12.6 14.4C13.6 14.1 14.3 13.3 14.4 12.2L15.6 10.7C15.8 11.1 15.9 11.6 15.9 12.1C15.9 14.1 14.1 15.9 12 15.9Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidenIcon);
export default __webpack_public_path__ + "static/media/hidenIcon.ecfd7f765675be8f7239211abc22b203.svg";
export { ForwardRef as ReactComponent };